module.exports = __webpack_public_path__ + "static/wave-8a821d349ca5fd6b7632eeb47e1cdccf.png";